import React from 'react';
import RedirectOffSite from 'app/ui/route/RedirectOffSite';
import { connect } from 'react-redux';
import { getBookshelfUrl } from 'app/api/redux-watson/watson-config-selectors';

function ForwardToBookshelf({ bookshelfUrl, location: { pathname, search } }) {
  const url = `${bookshelfUrl}/${pathname}${search}`;
  return <RedirectOffSite to={url} params={{ sso: true, newWin: false }} />;
}

export default connect(state => ({
  bookshelfUrl: getBookshelfUrl(state),
}))(ForwardToBookshelf);



// WEBPACK FOOTER //
// ./src/app/ui/pages/redirect/ForwardToBookshelf.js